import React, { Component } from 'react';

export default class browserCompatibility extends Component {

    render() {
        return (
            <div>
                <img src="/static/images/pectem_shell.png" className="pectem" alt="Shell" />
                <div className="container">
                    <div className="row">
                        <div className="col s12 m6 offset-m3">
                            <img src="/static/images/errors/404-icon.png" className="responsive-img" alt="Pagina no encontrada" />
                            <p className="text-center error-no">
                                <span>ERROR NAVEGADOR NO SOPORTADO</span>
                            </p>
                        </div>
                        <div className="col s12 m6 offset-m3 margin-top-50">
                            <p className="error-text" style={{fontSize: '1rem'}}>
                                Les informamos que los navegadores soportados para ingresar a la herramienta Viajes Fame y Ethanol son:
                            </p>
                            <ul>
                                <li>&bull; Google Chrome versión 40 o superior</li>
                                <li>&bull; Internet Explorer versión 11 o superior</li>
                            </ul>
                            <p className="error-text" style={{fontSize: '1rem'}}>
                                A continuación les facilitamos los links de descarga a los navegadores soportados:<br />
                            </p>
                            <p className={"text-center error-text"}>
                                <a href="https://www.google.com/intl/es_ALL/chrome/" target={"_blank"}>Descargar Chrome</a>
                                <a href="https://www.microsoft.com/es-es/download/internet-explorer-11-for-windows-7-details.aspx" target={"_blank"}>Descargar Explorer 11</a>
                            </p>
                            <p className="error-text" style={{fontSize: '1rem'}}>
                                Por favor notar que las versiones anteriores de Internet Explorer (versión 9 y versión 10) ya tienen 7-8 años de antigüedad, por lo que ya no soportan algunas funcionalidades modernas.
                                Esperamos que disfrute la nueva herramienta!
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/BrowserCompatibility/browserCompatibility.js